<template>
  <div class="pickup-tickets-container">
    <div class="pickup-tickets-wrapper">
      <header>{{ $t('update') }} {{ $tc('seat', 1) }} {{ $t('occupancy') }}</header>
      <button v-on:click="close()" class="btn-modal-close">&times;</button>
      <div class="pickup-tickets-center-content">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <input v-model="booking_id" id="seatOccupancyUpdate" type="text" />
            <label>{{ $tc('ticket', 1) }} {{ $t('no') }}</label>
            <VkeyboardFloat
            :ID="'seatOccupancyUpdate'"
            :onClickFun="() => {
              showVKeyboard = !showVKeyboard
            }"
          />
          <Vkeyboard
            :inputName="'seatOccupancyUpdate'"
            :showOrHide="showVKeyboard"
            :initialValue="booking_id"
            @onChangeEvent="() => {}"
            @onKeyEnter="showTicketInfomation"
            @changeKeyboardInput="booking_id = $event"
            @onClickClose="() => {
              showVKeyboard = false;
            }"
          />
          </div>
          <button class="btn-blue-lg" v-on:click="showTicketInfomation()">{{ $t('submit') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PosService from "@/services/PosService.js";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
export default {
  components: { Vkeyboard, VkeyboardFloat },
  data() {
    return {
      showVKeyboard: false,
      booking_id: ""
    };
  },
  methods: {
    close: function() {
      this.$router.go(-1);
    },
    showTicketInfomation: function() {
      if (this.booking_id == "") {
        alert("Please Enter valid Booking Id");
      } else {
        let payload = {
          booking_id: this.booking_id
        };
        PosService.updateSeatStatus(payload)
          .then(result => {
            const { data } = result;
            if (data.status) {
              this.$toasted.show('Seat Occupancy Updated Successfully')
              // alert("Seat Occupancy Updated Successfully");
            } else {
              this.$toasted.show(data.message)
              // alert(data.message);
            }
          })
          .catch(err => {
            this.$toasted.show("Something Went wrong");
          });
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posSeatOccupancy.vue